// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.pqri.PqriAlertRequest */
/* istanbul ignore next */
@GandalfModel
export class PqriAlertRequest extends GandalfModelBase {

	@GandalfLabel('Code')
	@GandalfValidator({ notNull: { message: 'Code is required' } })
	@GandalfProperty({ designType: String, isRequired: true })
	code!: string;

	@GandalfLabel('Dx Code')
	@GandalfValidator({ sizeString: { message: 'Dx Code cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	dxCode!: string | null;

}
